<template>
  <div class="affiliated-permission-management">
    <div v-for="(section, index) in permissions" :key="index">
      <div v-if="sectionIsVisible(section)" class="section mt-6">
        <span class="section-title"> {{ section.sectionTitle }}</span>
        <p class="section-subtitle mt-1">{{ section.sectionSubtitle }}</p>
        <div class="section-cards">
          <div v-for="(permission, index) in section.cards" :key="index">
            <permission-card
              v-if="cardIsVisible(permission)"
              v-model="localFranchiseePermissions[permission.permission]"
              :title="permission.title"
              :subtitle="permission.subtitle"
              :alertMessage="permission.alert"
            />
          </div>
        </div>
      </div>
    </div>
    <mf-action-buttons
      class="mt-4"
      :primary-button="{
        text: 'Salvar alterações',
        action: save,
        isVisible: true,
        isDisabled: disableButtons,
        isLoading: loadingSave,
      }"
      :extra-button="{
        text: 'Descartar alterações',
        action: cancel,
        isVisible: true,
        isDisabled: disableButtons,
      }"
    />
  </div>
</template>

<script>
import ManagementPermissions from '../../mocks/ManagementPermissions.js'
import isEqual from 'lodash/isEqual'

export default {
  components: {
    PermissionCard: () => import('./PermissionCard.vue'),
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    franchiseePermissions: {
      type: Object,
      default: () => {},
    },
    loadingSave: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    permissions: [],
    localFranchiseePermissions: {},
  }),
  computed: {
    disableButtons() {
      return isEqual(this.localFranchiseePermissions, this.franchiseePermissions)
    },
  },
  watch: {
    localFranchiseePermissions: {
      deep: true,
      handler(newValue) {
        this.$emit('input', newValue)
      },
    },
  },
  mounted() {
    this.permissions = [...ManagementPermissions]
    this.localFranchiseePermissions = { ...this.value }
  },
  methods: {
    save() {
      this.$emit('save', this.localFranchiseePermissions)
    },
    cancel() {
      this.localFranchiseePermissions = { ...this.franchiseePermissions }
      this.$snackbar({ message: 'Alterações descartadas com sucesso', snackbarColor: 'success' })
    },
    sectionIsVisible(section) {
      if (section.sectionTitle === 'Gestão de saldo e carteira') {
        return this.$getAllowedModules()['cashback'] || this.$getAllowedModules()['points']
      }
      return true
    },
    cardIsVisible(permission) {
      if (permission.permission === 'edit_cashback' || permission.permission === 'edit_points') {
        return this.$getAllowedModules()[permission.module]
      }
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
.affiliated-permission-management {
  padding: 0 18px;
  .section {
    &-subtitle {
      font-weight: 400;
      font-size: 16px;
      margin-bottom: 24px;
      color: $cinza-0;
    }
    &-cards {
      display: flex;
      flex-direction: column;
      row-gap: 20px;
    }
  }
}
</style>
